import React from "react";
import { cn } from "@gettactic/helpers";
import { LoadingSpinner } from "@cmp-src/loadings/LoadingSpinner";

type ImageProps = {
  src: string;
  alt?: string;
  className?: string;
  wrapperClassName?: string;
};

const classes = {
  Wrapper: "relative object-cover",
  Loading:
    "absolute inset-0 flex animate-pulse items-center justify-center bg-neutral-100",
  Spinner: "h-8 w-8 animate-spin text-neutral-500",
  Image: "h-full w-full object-cover transition-opacity duration-500"
};

export const Image: React.FC<ImageProps> = ({
  src,
  alt = "",
  className,
  wrapperClassName
}) => {
  const [isLoaded, setIsLoaded] = React.useState(false);
  const imgRef = React.useRef<HTMLImageElement>(null);

  // Reset loaded state when src changes
  React.useEffect(() => {
    setIsLoaded(false);
    // Check if image is already cached/complete
    if (imgRef.current?.complete && imgRef.current?.naturalWidth > 0) {
      setIsLoaded(true);
    }
  }, [src]);

  const handleLoad = React.useCallback(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={cn(classes.Wrapper, wrapperClassName)}>
      {!isLoaded && (
        <div className={classes.Loading}>
          <LoadingSpinner variant={"circular"} />
        </div>
      )}
      <img
        ref={imgRef}
        src={src}
        alt={alt}
        key={src}
        className={cn(
          classes.Image,
          !isLoaded ? "opacity-0" : "opacity-100",
          className
        )}
        onLoad={handleLoad}
      />
    </div>
  );
};
